'use client'
import React, { useState, useEffect, useRef } from 'react'
import SaleFilter from '@components/Search/SaleFilter'
import MinPriceFilter from '@components/Search/MinPriceFilter'
import MaxPriceFilter from '@components/Search/MaxPriceFilter'
import MinRentPriceFilter from '@components/Search/MinRentPriceFilter'
import MaxRentPriceFilter from '@components/Search/MaxRentPriceFilter'
// import BtsFilter from '@components/Search/BtsFilter'
import CategoryFilter from '@components/Search/CategoryFilter'
// import RoomFilter from '@components/Search/RoomFilter'
// import PetFriendlyFilter from '@components/Search/PetFriendlyFilter'
import SeaViewFilter from '@components/Search/WebFilter/SeaViewFilter'
import BeachfrontFilter from '@components/Search/WebFilter/BeachfrontFilter'
import MultiDistrictFilter from '@components/Search/MultiDistrictFilter'

import SortFilter from '@components/Search/SortFilter'
import IdFilter from '@components/Search/IdFilter'

import { saleTypes, categoryTypes, roomTypes, roomHouseTypes, condoRoomTypes, houseRoomTypes } from '@constants'
import { AiOutlineMenuFold } from 'react-icons/ai'
import { FaMapMarkerAlt, FaList } from 'react-icons/fa'
import tailwindConfig from '@tailwind.config'
import { updateSearchParams, removeParams, removeSearchParam } from "@utils";
import { useRouter } from 'next/navigation'




const FilterTab = ({ searchParams, lang, dictionary }) => {
    const router = useRouter();

    const filterRef = useRef(null);


    // const [isFilterOpen, setIsFilterOpen] = useState(router?.query?.filter || false);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [filterOn, setFilterOn] = useState(false);
    const [search, setSearch] = useState(searchParams)
    const [salePriceFilter, setSalePriceFilter] = useState(searchParams.saleType || saleTypes[lang][0].value)
    const [categoryFilter, setCategoryFilter] = useState(searchParams.category)
    // const [sort, sortFilter] = useState(searchParams.sort || 'datedesc')
    const [showMap, setShowMap] = useState(searchParams.map || false);

    useEffect(() => {
        function openFilterTab() {
            setIsFilterOpen(true)
        }

        let openFilter = searchParams.filtertab

        if (openFilter == 'true') {
            openFilterTab()
        }
    }, [])

    const handleMapChange = (e) => {
        setShowMap(e);
        let newPathName
        if (e == true) {
            newPathName = updateSearchParams('map', true);
        } else {
            newPathName = removeSearchParam('map');
        }

        router.push(newPathName);
        router.refresh()
    };

    useEffect(() => {
        if (!filterRef?.current) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    filterRef.current.style.position = 'sticky';
                    filterRef.current.style.top = '0';
                }/* else {
                    filterRef.current?.style.position = 'absolute';
                    filterRef.current?.style.top = '20px'; // Adjust as needed
                }*/
            },
            {
                root: null,
                threshold: 0,
            }
        );

        observer.observe(filterRef.current);

        // return () => {
        //     observer.unobserve(filterRef.current);
        // };
    }, []);

    useEffect(() => {
        // const searchPar = new URLSearchParams(window.location.search);
        if (search != searchParams) {
            setSearch(searchParams)
            if (searchParams.saleType === 'rent') {
                setSalePriceFilter('rent')
                // updateSearchParams('minprice', '0');
                // updateSearchParams('maxprice', '10000000');
            } else {
                setSalePriceFilter(saleTypes[lang][0].value)
                // updateSearchParams('minprice', '0');
                // updateSearchParams('maxprice', '10000000');
            }

            if (searchParams.category === 'condo') {
                setCategoryFilter('condo')
                // updateSearchParams('minprice', '0');
                // updateSearchParams('maxprice', '10000000');
            } else if (searchParams.category === 'house') {
                setCategoryFilter('house')
                // updateSearchParams('minprice', '0');
                // updateSearchParams('maxprice', '10000000');
            } else if (searchParams.category == undefined) {
                setCategoryFilter(undefined)
            } else {
                setCategoryFilter('')
            }

            if (searchParams.category !== undefined || searchParams.room !== undefined || searchParams.minprice !== undefined || searchParams.maxprice !== undefined) {
                setFilterOn(true)
            } else {
                setFilterOn(false)
            }
        }
    }, [searchParams])

    return (
        <div className='w-full z-[89] relative bg-light' ref={filterRef}>
            {isFilterOpen && (
                <div onClick={() => (setIsFilterOpen(false))} className='fixed top-0 left-0 right-0 bottom-0 bg-secondary bg-opacity-50' ></div>
            )}
            <div className='sm:w-full 2xl:w-10/12 flex justify-between items-center py-1 px-3 mx-auto border-b-[1px] border-forth'>
                <span className='text-maincolor'>{dictionary.filter.properties}:</span>
                <div className='flex flex-row'>
                    {/* <div onClick={() => handleMapChange(!showMap)} className={`relative flex flex-row items-center border-[1px] ${showMap ? 'border-maincolor hover:border-secondary' : 'border-forth hover:border-maincolor'}  p-1 cursor-pointer mr-2`} title='Toggle Map' >
                        <span className='text-maincolor mr-1 select-none'>{showMap ? dictionary.filter.list : dictionary.filter.map}</span>
                        {showMap ? (
                            <FaList
                                color={tailwindConfig.theme.extend.colors.maincolor}
                            />
                            ) : (
                            <FaMapMarkerAlt
                                color={tailwindConfig.theme.extend.colors.maincolor}
                            />
                        )}
                    </div> */}
                    <div onClick={() => (setIsFilterOpen(true))} className='relative flex flex-row items-center border-[1px] border-forth hover:border-maincolor p-1 cursor-pointer rounded-sm' title='Toggle Filter'>
                        {filterOn && (
                            <div className='absolute h-2 w-2 rounded-full bg-third top-1 right-1 z-30'></div>
                        )}
                        <span className='text-maincolor mr-1 select-none'>{dictionary.filter.filter}</span>
                        <AiOutlineMenuFold
                            color={tailwindConfig.theme.extend.colors.maincolor}
                        />
                    </div>
                </div>

            </div>
            {isFilterOpen ? (
                <div className='absolute top-0 left-0 right-0 z-[100] flex items-center'>
                    <div onClick={() => (setIsFilterOpen(false))} className='absolute z-20 top-0 left-0 right-0 bottom-0'></div>
                    <div className='sm:w-full 2xl:w-10/12 mx-auto z-30'>
                        <div className='w-full bg-light border-b-[1px] border-b-maincolor shadow-md px-3 rounded-sm'>
                            <div className='w-full flex justify-between items-center pt-1'>
                                {/* <span className='text-maincolor'>Properties:</span> */}
                                <div className='flex flex-row justify-end w-full'>

                                    {/* <div onClick={() => handleMapChange(!showMap)} className={`relative flex flex-row items-center border-[1px] ${showMap ? ' border-maincolor' : 'border-forth'} p-1 cursor-pointer mr-2`}>
                                        <span className='text-maincolor mr-1 select-none'>{showMap ? dictionary.filter.list : dictionary.filter.map}</span>
                                        <FaMapMarkerAlt
                                            color={tailwindConfig.theme.extend.colors.maincolor}
                                        />
                                    </div> */}
                                    <div onClick={() => (setIsFilterOpen(false))} className='relative flex flex-row items-center border-[1px] border-maincolor p-1 cursor-pointer rounded-sm'>
                                        {filterOn && (
                                            <div className='absolute h-2 w-2 rounded-full bg-third top-1 right-1 z-30'></div>
                                        )}
                                        <span className='text-maincolor mr-1 select-none'>{dictionary.filter.close}</span>
                                        <AiOutlineMenuFold
                                            color={tailwindConfig.theme.extend.colors.maincolor}
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* <div className='sm:w-full xl:w-1/2'> */}
                            <div className='w-full flex sm:flex-row flex-col sm:items-start mt-1'>
                                <div className='sm:w-1/2 w-full sm:pr-1'>
                                    {saleTypes[lang].length > 1 &&
                                        <SaleFilter title="saleType" dictionary={dictionary} lang={lang} />
                                    }
                                    {salePriceFilter === 'sale' ? (
                                        <div className='w-full flex flex-row gap-2'>
                                            <MinPriceFilter title="minprice" dictionary={dictionary} lang={lang} />
                                            <MaxPriceFilter title="maxprice" dictionary={dictionary} lang={lang} />
                                        </div>
                                    ) : (
                                        <div className='w-full flex flex-row gap-2'>
                                            <MinRentPriceFilter title="minprice" dictionary={dictionary} lang={lang} />
                                            <MaxRentPriceFilter title="maxprice" dictionary={dictionary} lang={lang} />
                                        </div>
                                    )}

                                    
                                    <CategoryFilter title="category" dictionary={dictionary} lang={lang} />
                                    {/* {(categoryFilter === 'condo' || categoryFilter === undefined) &&
                                        <RoomFilter title="room" roomTypes={condoRoomTypes} dictionary={dictionary} lang={lang} />
                                    }
                                    {categoryFilter === 'house' &&
                                        <RoomFilter title="room" roomTypes={houseRoomTypes} dictionary={dictionary} lang={lang} />
                                    } */}
                                </div>
                                <div className='sm:w-1/2 w-full sm:pl-1'>
                                    <div className='mr-2'>
                                        <IdFilter title='name' dictionary={dictionary} lang={lang} />
                                    </div>
                                    <div className='w-full sm:pr-1'>
                                        <>
                                            <SeaViewFilter title='seaview' dictionary={dictionary} lang={lang} />
                                            <BeachfrontFilter title='beachfront' dictionary={dictionary} lang={lang} />
                                            {/* <PetFriendlyFilter title='petfriendly' dictionary={dictionary} lang={lang} /> */}
                                        </>
                                    </div>
                                </div>
                            </div>
                            {/* <div className='flex sm:flex-row flex-col mt-1 items-center'>
                                <div className='sm:w-1/2 w-full sm:pr-1'>
                                    {(categoryFilter === 'condo' || categoryFilter === undefined || categoryFilter === 'house') && (
                                    <>
                                        <SeaViewFilter title='seaview' dictionary={dictionary} lang={lang} />
                                        <BeachfrontFilter title='beachfront' dictionary={dictionary} lang={lang} />
                                        <PetFriendlyFilter title='petfriendly' dictionary={dictionary} lang={lang} />
                                    </>
                                    )}
                                </div>
                            </div> */}
                            <div className='flex sm:flex-row flex-col-reverse mt-1 items-center'>
                                <div className='sm:w-1/2 w-full flex flex-row justify-between mt-4 mb-3 my-2 gap-2'>
                                    <button className='bg-third text-light rounded-sm p-1 font-semibold sm:1/3 w-1/2' onClick={() => removeParams()}>{dictionary.filter.reset}</button>
                                    <button className='bg-maincolor text-light rounded-sm p-1 font-semibold sm:1/3 w-1/2' onClick={() => (setIsFilterOpen(false))}>{dictionary.filter.apply}</button>
                                </div>
                                <div className='sm:w-1/2 w-full sm:pl-1'>
                                    <SortFilter title='sort' dictionary={dictionary} lang={lang} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : null
            }
        </div >
    )
}

export default FilterTab